import React from 'react';
import { connect } from 'react-redux';
import TranslationService from "../../../app/services/TranslationService";
import Bloobs from "../../Bloobs";
import {config} from "../../../app/config";
import { marked } from "marked";
import {WavingTriangle} from "../../WavingTriangle";


export class TalkClass extends React.Component {
    imgPreviews = {};

    /**
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            messages: this.props.messages,
            screenType: this.getScreenType(),
            imgPreviews: 0
        }
    }

    componentDidMount() {
        var objDiv = document.getElementById("system-talk-preview");
        if (objDiv) {
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.screenType !== this.getScreenType()) {
            this.setState({screenType: this.getScreenType()});
        }

        var objDiv = document.getElementById("system-talk-preview");
        if (objDiv) {
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    }

    getScreenType = () => {
        return localStorage.getItem('talk_screen') === 'calm' ? 'calm' : 'standard';
    }

    renderMessages = () => {
        let messages = [];

        let that = this;
        this.state.messages.forEach(function(message, key) {
            messages.push(<div key={'q-' + key} className="imd-row message">
                <div className="imd-col-11 imd-offset-1 t-query">
                    <div className="imd-border-color-140-main imd-text-main">{message.query}</div>
                </div>
            </div>);

            if (message.answer !== null) {
                if (Object.keys(that.imgPreviews).indexOf(key.toString()) === -1) {
                    that.imgPreviews[key] = false;
                }

                messages.push(<div key={'a-' + key} className="imd-row message">
                    <div className="imd-col-1" style={{textAlign: 'right'}}>
                        { that.state.screenType === 'calm' ?
                            <span className="icymat andra imd-text-main" style={{fontSize: '30px'}} /> :
                            // <AndraContainer scale={1} style={{margin: '0', display: key === counter ? 'block' : 'none' }} />
                            <WavingTriangle size={30} lines={0} />
                        }
                    </div>
                    <div className="imd-col-11 t-answer">
                        <div className={'imd-text-accent ' + (that.state.screenType === 'standard' ? 'icymat-ai' : 'imd-border-color-170-accent')}>
                            <div className="real-content">
                                {/*{ that.state.screenType === 'standard' ?*/}
                                {/*    <IcyMatAI size={'1.5em'} visible={message.instruction === 'ai' || message.instruction === 'img'} style={{float: 'right'}} /> :*/}
                                {/*    null*/}
                                {/*}*/}

                                <span dangerouslySetInnerHTML={{ __html: marked.parse(message.answer) }} />

                                {
                                    message.instruction === 'img' ?
                                        <div className={"imd-table-responsive"} style={{textAlign: 'center', marginTop: '10px'}}>
                                            <img
                                                src={config.apiAddress + '/image/' + message.data + '.png'}
                                                style={that.imgPreviews[key] ? {maxWidth: '100%', cursor: 'pointer'} : {maxWidth: '90vw', maxHeight: '250px', cursor: 'pointer'}}
                                                alt={TranslationService.trans(that.props.language, 'main.image_answer', that.props.user)}
                                                onClick={() => {that.imgPreviews[key] = !that.imgPreviews[key]; that.setState({imgPreviews: that.state.imgPreviews + 1});}}
                                            />
                                        </div>:
                                        ''
                                }

                                {
                                    message.html !== null ?
                                        <div dangerouslySetInnerHTML={{ __html: message.html }} /> :
                                        ''
                                }
                            </div>
                        </div>
                    </div>
                </div>);
            }
        });

        return messages;
    }

    render() {
        return (
            <div className={'imd-container-fluid talk' + (this.state.screenType === 'calm' ? ' imd-bg-transparent-black' : '')} id="system-talk-preview" style={{height: this.props.height}}>
                {this.renderMessages()}

                <div style={{scale: 0.5}}>{this.props.thinking ? <Bloobs height={'50px'} /> : ''}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user)
    }
};

export const TalkScreen = connect(mapStateToProps, {})(TalkClass);
